import React from 'react';
import {ImageProps} from './Image.props';
import './Image.styles.css';

export const Image: React.FC<ImageProps> = ({
  srcImg,
  width = '200px',
  height = 'auto',
  backgroundColor = 'transparent',
  borderRadius = '0px',
  border = 0,
  margin = 0,
  onClick,
  cssClass,
  color,
  alt = '',
  ...props
}) => {
  return (
    <img
      alt={alt}
      className={`image-style ${cssClass}`}
      src={srcImg} style={{
        width,
        height,
        backgroundColor,
        borderRadius,
        border,
        margin,
        color
      }}
      onClick={onClick}
      {...props}
    />
  );
};
